import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import formimg from "../Forms/Performance-Appraisal-Templates-1-1013x439 1.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Select from "react-select";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

function MainSkills() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [categoriesndata, setCategoriesData] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const id = localStorage.getItem("employeeid");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [isManagerorHR, setIsManagerorHR] = useState(false);
  const [file, setFile] = useState(null);

  const [showToast, setShowToast] = useState(false);

  const navigate = useNavigate();
  const usernameRef = useRef(null);
  let mgr = searchParams.get("mgr");

  if (mgr === null || mgr === "") {
    mgr = "0";
  }

  const handleSubmit = async (values) => {
    if (isManagerorHR === false) {
      //currently logged in user id is set if user is normal user
      values.singleassignee = id;
    } else {
      values.singleassignee = "";
    }

    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  useEffect(() => {
    let role = localStorage.getItem("userrole");
    setIsManagerorHR(
      role === "ROLE_MANAGER" ||
        role === "ROLE_SUPERVISOR" ||
        role === "ROLE_HR"
    );
  }, []);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getskillcategories`
        );
        setCategoriesData(response.data.categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchOptions();
  }, []);
  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getteamlist?id=` + id
        );
        const data = response.data;
        let arrTeamdata = data.team;
        setTeamMembers(arrTeamdata);

        // console.log(data);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchData();
  }, []);

  const handleFileChange = (e) => {
    if (e.target.files) {
      let fileval = e.target.files[0];
      setFile(fileval);
    }
  };

  // const handleConfirmSubmit = async () => {
  //     const  response=[];
  //   try {

  //     const updatedFormData = { ...formData };

  //   // Append the file to the existing formData
  //   if(file !==null) {
  //     updatedFormData.certificate = file;
  //   }
  //   const formDataToSend = new FormData();

  //       // Construct a new FormData object

  //       for (const key in updatedFormData) {
  //         formDataToSend.append(key, updatedFormData[key]);
  //       }

  //   // Send the formData with the file to the server
  //   if(file !==null) {
  //     response = await fetch('http://localhost:3050/addskill', {
  //     method: 'POST',
  //     body: formDataToSend,
  //     });
  //   }
  //   else
  //   {
  //     if(formData.singleassignee  !==undefined  && formData.singleassignee  !=="" && formData.singleassignee  !==null)
  //     {
  //       //nothing to do
  //     }
  //     else
  //     {
  //       formData.singleassignee="No";
  //     }
  //      let stringifiedformvalues = JSON.stringify(formData);
  //        response = await axios.post('http://localhost:3050/addskillnocert', stringifiedformvalues, {
  //       headers: {
  //         'Content-Type': 'application/json' // Set the Content-Type header to indicate that the request body is JSON
  //       }
  //     });
  //   }

  //     if (response.ok) {
  //       setFormData(null);
  //       setShowModal(false);

  //       window.location.href = "/skills";
  //     } else {
  //       console.error('Form submission failed:', response.statusText);
  //     }
  //   } catch (error) {
  //     console.error("An error occurred:", error);
  //   }
  // };

  const handleConfirmSubmit = async () => {
    try {
      let response;
      const updatedFormData = { ...formData };

      // Append the file to the existing formData
      if (file !== null) {
        updatedFormData.certificate = file;
      }

      // Send the formData with the file to the server
      if (file !== null) {
        const formDataToSend = new FormData();
        for (const key in updatedFormData) {
          formDataToSend.append(key, updatedFormData[key]);
        }
        response = await fetch(`${baseURL}/addskill`, {
          method: "POST",
          body: formDataToSend,
        });
      } else {
        if (!formData.singleassignee) {
          formData.singleassignee = "No";
        }
        const stringifiedformvalues = JSON.stringify(formData);
        response = await axios.post(
          `${baseURL}/addskillnocert`,
          stringifiedformvalues,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }

      if (response.status === 200) {
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/skills");
        }, 3000);
        // window.location.href = "/skills";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          skillname: "",
          skilllevel: "",
          justification: "",
          progress: "0",
          category: "",
          assignees: "",
          createdby: id,
          singleassignee: "",
          certificate: "",
        }}
        validationSchema={Yup.object({
          skillname: Yup.string().required("Skill name is required"),
          skilllevel: Yup.string().required("Skill level is required"),
          justification: Yup.string().required("Justification is required"),
          category: Yup.string().required("Category is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
        }) => (
          <div className="container">
            <h4 className="text-start  pb-2">ADD Skills</h4>
            <div className="col-lg-12  mt-1 m-5">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-5 ">
                    <label className="formlabel">
                      Skill <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.skillname && errors.skillname
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter title"
                      name="skillname"
                      value={values.skillname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.skillname && errors.skillname ? (
                      <div className="text-danger">{errors.skillname}</div>
                    ) : null}
                  </div>
                  <div class="col-lg-5 ml-5">
                    <label>Skill Level</label>
                    <select
                      className="form-select form-control"
                      name="skilllevel"
                      value={values.skilllevel}
                      onChange={handleChange}
                    >
                      <option value="0">Select</option>
                      <option value="1">Beginner</option>
                      <option value="2">Intermediate</option>
                      <option value="3">Advanced</option>
                    </select>
                  </div>
                  <div className="col-lg-5 mt-2">
                    <label>Justification</label>
                    <textarea
                      className={`form-control ${
                        touched.justification && errors.justification
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter description"
                      name="justification"
                      value={values.justification}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {touched.justification && errors.justification ? (
                      <div className="text-danger">{errors.justification}</div>
                    ) : null}
                  </div>
                  <div class="col-lg-5 mt-2 ml-5">
                    <label>Progress (%)</label>
                    <br />
                    <input
                      type="number"
                      className="form-control"
                      min={0}
                      name="progress"
                      onChange={handleChange}
                      value={values.progress}
                    ></input>
                  </div>
                  <div class="col-lg-5 mt-2">
                    <label>Category</label>
                    <select
                      className="form-select form-control"
                      name="category"
                      value={values.category}
                      onChange={handleChange}
                    >
                      <option selected>Selected Category</option>
                      {categoriesndata &&
                        categoriesndata.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.categoryname}
                          </option>
                        ))}
                    </select>
                  </div>

                  {isManagerorHR && mgr === "0" ? (
                    <div className="col-lg-5 mt-2 ml-5">
                      <label>Assignees</label>
                      <br />

                      <Select
                        className=""
                        name="assignees"
                        value={
                          values.assignees &&
                          values.assignees.map((value) => ({
                            value,
                            label: value,
                          }))
                        }
                        onChange={(selectedOptions) => {
                          const selectedValues = selectedOptions.map(
                            (option) => option.value
                          );
                          setFieldValue("assignees", selectedValues);
                        }}
                        options={teamMembers.map((member, index) => ({
                          value: member.employeeid,
                          label: member.FirstName,
                        }))}
                        getOptionLabel={(option) =>
                          `${option.label} - ${option.value}`
                        }
                        isMulti
                      />
                    </div>
                  ) : (
                    <div className="col-lg-5 mt-2 ml-5">
                      <>
                        <input
                          type="hidden"
                          name="singleassignee"
                          value={(values.singleassignee = id)}
                        />
                        <label>Certificate</label>
                        <input
                          value={values.certificate}
                          id="file"
                          type="file"
                          onChange={handleFileChange}
                        />
                        {file && file !== null && <p>{file.name}</p>}
                      </>
                    </div>
                  )}
                  {/* <div className="col-lg-5 mt-2">
                  <label>Upload Certificate(Only PDF)</label>
                  <input
                    type="file"
                    accept=".pdf"
                    className="form-control"
                    name="file"
                    onChange={(event) => {
                      setFieldValue("file", event.currentTarget.files[0]);
                    }}
                  />
                     </div> */}
                </div>
                {/* New file upload field */}

                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a href="/Skills" className="text-decoration-none ">
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Confirm the changes?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default MainSkills;
